// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardPartRequiredFilter.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------
import { isEmpty } from 'lodash/fp';
import React from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import * as mobx from 'mobx';
const DashboardPartRequiredFilter = ({
  localization,
  filters
}: {
  localization: any,
  filters: Array<any>
}) => {
  const buildListFilter = (filtersList: Array<any>) => {
    if (isEmpty(filtersList)) {
      return null;
    }

    return (
      <div className='u-center izenda-ReportViewer-FilterList'>
        {filtersList.map(filter => (
          <p key={filter.filterField.position}>{`Filter #${filter.filterField.position} - ${
            filter.filterField.alias
          }`}</p>
        ))}
      </div>
    );
  };

  return (
    <div className='u_table u_fullSize'>
      <div className='u_tableCell u_alignMiddle u_textCenter'>
        {localization.getText('REPORTS_CONSTANTS_REPORT_MESSAGE_SELECT_REQUIRE_AND_VISIBLE_FIELD')}
        {buildListFilter(filters)}
      </div>
    </div>
  );
};

export default connect()(DashboardPartRequiredFilter);



// WEBPACK FOOTER //
// ./ui/modules/Dashboard/DashboardDesigner/DashboardGrid/DashboardTile/ReportPartTile/Izenda.DashboardPartRequiredFilter.js